import { type FunctionComponent, Suspense } from 'react';
import { useStrategyRiskMetricsSuspenseQuery } from 'generated/graphql.tsx';

import { PortfolioOptimizerRiskMetrics } from '../PortfolioOptimizerRiskMetrics.tsx';
import GErrorBoundary from 'components/technical/GErrorBoundary.tsx';
import KeyValueListSkeleton from 'components/technical/KeyValueListSkeleton.tsx';

const StrategyRiskMetricsContainer: FunctionComponent<{ strategy: Label }> = ({ strategy }) => {
  const { data } = useStrategyRiskMetricsSuspenseQuery({ variables: { label: strategy } });
  return (
    <GErrorBoundary variant="inline">
      <Suspense fallback={<KeyValueListSkeleton />}>
        <PortfolioOptimizerRiskMetrics
          result={data.strategy.strategyRiskMetrics.map((metric) => ({ ...metric, params: {} }))}
        />
      </Suspense>
    </GErrorBoundary>
  );
};

export default StrategyRiskMetricsContainer;
